import alreadyTableBody from './utils/alreadyTableBody';
import alreadyTableHead from './utils/alreadyTableHead';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLTableElement {
        alreadyTableHead(config?: Record<string, any>): HTMLTableSectionElement;
        alreadyTableBody(config?: Record<string, any>): HTMLTableSectionElement;
    }
}

// ----------------------------------------------------------------------------

HTMLTableElement.prototype.alreadyTableHead = function (config?: Record<string, any>): HTMLTableSectionElement {
    return alreadyTableHead(this, config);
};

HTMLTableElement.prototype.alreadyTableBody = function (config?: Record<string, any>): HTMLTableSectionElement {
    return alreadyTableBody(this, config);
};
